import { formatDate } from 'common/services/format'
import type { PhysicianIntroduction } from 'features/Procedure/state/procedure-api.type'

export const toLocalDateTime = (date: Date): string => {
  const pad = (value: number): string => String(value).padStart(2, '0')
  const year = date.getFullYear()
  const month = pad(date.getMonth() + 1)
  const day = pad(date.getDate())
  const hours = pad(date.getHours())
  const minutes = pad(date.getMinutes())
  const seconds = pad(date.getSeconds())
  return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`
}

export const formatProviderSince = (providerSince: string): string => formatDate(providerSince)

export const buildPhysicianName = (physician: PhysicianIntroduction): string =>
  [physician.title, physician.fname, physician.mname, physician.lname]
    .map((part) => part?.trim())
    .filter(Boolean)
    .join(' ')

export const formatPhysicianType = (physician: PhysicianIntroduction): string => {
  if (physician.specialty?.trim()) return physician.specialty.trim()
  if (!physician.physician_type) return ''
  return physician.physician_type
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ')
}
